import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./utility/filters";

// Registration of global components
import dayjs from "dayjs";
Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });
//--------------------------------------------------------------------
//Validation framework
//--------------------------------------------------------------------
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
//--------------------------------------------------------------------

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
